import { CurrencyPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
/* import { BudgetRequestStatusPipe } from './budget-request-status.pipe';
import { DeletedPipe } from './deleted.pipe';
import { PhonePipe } from './phone.pipe';
 */
import { PlnTableComponent } from "../components/pln-table/pln-table.component";
import { ActiveInactivePipe } from "./active-inactive.pipe";
import { DbDatePipe } from "./db-date.pipe";
import { RequestStatusPipe } from "./request-status.pipe";
/* import { ActiveInactivePipe } from './active-inactive.pipe';
import { BudgetStatusPipe } from './budget-status.pipe';
import { ChargeTypePipe } from './charge-type.pipe';
import { CodeRevision } from './code-revision.pipe';
import { CompanyPipe } from './company.pipe';
import { ContractStatusPipe } from './contract-status.pipe';
import { CpfCnpjPipe } from './cpf-cnpj.pipe';
import { DismissalChecklistStatusPipe } from './dismissal-checklist-status.pipe';
import { ExternalDocumentStatusPipe } from './external-document-status.pipe';
import { ExternalOccurrenceStatusPipe } from './external-occurrence-status.pipe';
import { FirstUpperPipe } from './first-upper.pipe';
import { InternalDocumentStatusPipe } from './internal-document-status.pipe';
import { MobilePhoneNumberStatusPipe } from './mobile_phone_number_status.pipe';
import { usedForPipe } from './mobile_phone_number_type.pipe';
import { PercentagePipe } from './percentage.pipe';
import { PrintTypePipe } from './print-type.pipe';
import { VacancyCurriculumStatusPipe } from './vacancy-curriculum-status.pipe';
import { VacancyStatusPipe } from './vacancy-status.pipe';
import { YesNoPipe } from './yes-no.pipe';
import { StatusPipe } from './status.pipe'; */

@Pipe({
  name: "plnTableValue",
})
export class PlnTableValuePipe implements PipeTransform {
  transform(data: any, column: any): any {
    try {
      const locale = "pt-br";
      let pipeTransform: any;

      switch (column.type) {
        case PlnTableComponent.fieldValue().monetary:
          pipeTransform = new CurrencyPipe(locale);
          break;
        case PlnTableComponent.fieldValue().requestStatus:
          pipeTransform = new RequestStatusPipe();
          break;
        case PlnTableComponent.fieldValue().date:
          pipeTransform = new DbDatePipe();
          break;
        case PlnTableComponent.fieldValue().activeInactive:
          pipeTransform = new ActiveInactivePipe();
          break;
          /*   case PlnTableComponent.fieldValue().boolean:
          pipeTransform = new YesNoPipe();
          break;
        case PlnTableComponent.fieldValue().percentual:
          pipeTransform = new PercentagePipe();
          break;
        case PlnTableComponent.fieldValue().chargeType:
          pipeTransform = new ChargeTypePipe();
          break;
        case PlnTableComponent.fieldValue().externalDocumentStatus:
          pipeTransform = new ExternalDocumentStatusPipe();
          break;
        case PlnTableComponent.fieldValue().internalDocumentStatus:
          pipeTransform = new InternalDocumentStatusPipe();
          break;
        case PlnTableComponent.fieldValue().firstUpper:
          pipeTransform = new FirstUpperPipe();
          break;
        case PlnTableComponent.fieldValue().cpfCnpj:
          pipeTransform = new CpfCnpjPipe();
          break;
        case PlnTableComponent.fieldValue().vacancyStatus:
          pipeTransform = new VacancyStatusPipe();
          break;
        case PlnTableComponent.fieldValue().vacancyCurriculumStatus:
          pipeTransform = new VacancyCurriculumStatusPipe();
          break;
        case PlnTableComponent.fieldValue().company:
          pipeTransform = new CompanyPipe();
          break;
        case PlnTableComponent.fieldValue().budgetStatus:
          pipeTransform = new BudgetStatusPipe();
          break;
        case PlnTableComponent.fieldValue().contractStatus:
          pipeTransform = new ContractStatusPipe();
          break;
        case PlnTableComponent.fieldValue().budgetRequestStatus:
          pipeTransform = new BudgetRequestStatusPipe();
          break;
        case PlnTableComponent.fieldValue().dismissalChecklistStatus:
          pipeTransform = new DismissalChecklistStatusPipe();
          break;
        case PlnTableComponent.fieldValue().codeRevision:
          pipeTransform = new CodeRevision();
          break;
        case PlnTableComponent.fieldValue().printType:
          pipeTransform = new PrintTypePipe();
          break;
        case PlnTableComponent.fieldValue().deleted:
          pipeTransform = new DeletedPipe();
          break;
        case PlnTableComponent.fieldValue().usedFor:
          pipeTransform = new usedForPipe();
          break;
        case PlnTableComponent.fieldValue().mobilePhoneNumberStatus:
          pipeTransform = new MobilePhoneNumberStatusPipe();
          break;
        case PlnTableComponent.fieldValue().phone:
          pipeTransform = new PhonePipe();
          break;
        case PlnTableComponent.fieldValue().externalOccurrenceStatus:
          pipeTransform = new ExternalOccurrenceStatusPipe();
          break;
        case PlnTableComponent.fieldValue().status:
          pipeTransform = new StatusPipe(); */
          break;
        default:
          return data[column.value];
      }
      // pipeTransform.transform(data[column.value], 'BRL');
      return pipeTransform.transform(
        data[column.value],
        PlnTableComponent.fieldValue().monetary ? "BRL" : ""
      );
    } catch (err) {
      return data[column.value];
    }
  }
}
